import { Link } from 'react-router-dom';
import {
  ArrowRight, Star, Play,
  CheckCircle2, MessageSquare,
} from 'lucide-react';
import { Button } from '@/components/ui/button';

export const Hero = () => (
  <section id="main-content" className="relative overflow-hidden">
    <div className="absolute inset-0 bg-gradient-to-br from-primary/5 via-transparent to-blue-50/30" />
    <div className="max-w-6xl mx-auto px-6 py-24 md:py-32 relative">
      <div className="max-w-2xl">
        <div className="flex flex-wrap items-center gap-2 mb-6">
          <div className="inline-flex items-center gap-2 bg-primary/10 text-primary text-xs font-medium px-3 py-1.5 rounded-full">
            <Star className="w-3 h-3" />
          Schaltzentrale für Ernährungstherapie
          </div>
        </div>
        <h1 className="font-serif text-4xl font-medium leading-tight tracking-[-0.015em] text-ink md:text-5xl">
          Icarus D&D.{' '}
          <span className="text-primary">Das Dietitian Dashboard.</span>
        </h1>
        <p className="mt-6 text-lg text-gray-700 leading-relaxed max-w-xl">
          Die DSGVO-konforme Praxis-Schaltzentrale für Termine, Teletherapie,
          Patientenportal, Rechnungen und prüfbare Dokumentation. Die KI
          dokumentiert und sortiert, trifft aber keine medizinischen
          Entscheidungen.
        </p>
        <div className="mt-3 flex flex-col gap-1.5">
          <p className="text-sm text-gray-700 flex items-center gap-1.5">
            <CheckCircle2 className="w-4 h-4 text-primary shrink-0" />
            Praxis-MVP mit Voice-Doku, GNCP-Werkbank und Patientenportal
          </p>
          <p className="text-sm text-gray-700 flex items-center gap-1.5">
            <CheckCircle2 className="w-4 h-4 text-primary shrink-0" />
            Auto-Doku mit Review, Belegstellen und fachlicher Freigabe
          </p>
          <p className="text-sm text-gray-700 flex items-center gap-1.5">
            <CheckCircle2 className="w-4 h-4 text-primary shrink-0" />
            Keine Diagnose-, Therapie- oder Risikoempfehlungen im öffentlichen MVP
          </p>
        </div>
        <div className="mt-8 flex flex-wrap gap-3">
          <a href="mailto:info@icarus-health.de?subject=Demo-Anfrage%20D%3AE%3AF%3AY">
            <Button size="lg" className="bg-primary hover:bg-primary/90 text-white rounded-xl text-base px-6 h-12 font-semibold">
              <MessageSquare className="w-4 h-4 mr-2" />
              Demo anfragen
            </Button>
          </a>
          <Link to="/login">
            <Button size="lg" variant="outline" className="rounded-xl text-base px-6 h-12 border-2 border-amber-400 text-amber-800 hover:bg-amber-50 font-semibold">
              <Play className="w-4 h-4 mr-2" />
              Interaktive Demo starten
            </Button>
          </Link>
          <Link to="/login">
            <Button size="lg" variant="outline" className="rounded-xl text-base px-6 h-12 border-gray-300 text-gray-700 hover:bg-gray-50 font-medium">
              Login
              <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
          </Link>
        </div>
      </div>
    </div>
  </section>
);
